<template>
  <div class="taoBao">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="queryList"
        v-model:inputValue="mydata.form.search"
      ></inputBox>
    </div>

    <!-- 面包屑 -->
    <!-- <div class="title-left">
      <el-breadcrumb>
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/layout/list/teacherHand"
          >教师助手</el-breadcrumb-item
        >
        <el-breadcrumb-item>研究成果</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->

    <!-- 模块2 -->
    <div class="box-worksdisplay1">
     
      <!-- 学段筛选按钮 -->
      <subjectButton
        :filterButton="mydata.filterButton1"
        style="margin-bottom: 10px"
        @change="change1"
        :key="mydata.testKey0"
      ></subjectButton>
      <!-- 学科筛选按钮 -->
      <subjectButton
        :key="mydata.testKey"
        :filterButton="mydata.filterButton2"
        @change="change3"
        style="margin-bottom: 10px"
      ></subjectButton>
      <!-- 主题筛选按钮 -->
      <subjectButton2
        :key="mydata.testKey2"
        :filterButton="mydata.filterButton3"
        @change="change2"
        textWidth="59px"
      ></subjectButton2>
    </div>
    <!--模块3  -->
    <div class="box-worksdisplay2">
      <div class="box-left">
        <div>
          <worksDisplayCards2
            :path="mydata.worksDisplay_path"
            v-for="(item, index) in mydata.articleListArr"
            :key="index"
            :info="item"
          ></worksDisplayCards2>
          <!-- 空白内容组件 -->
          <glEmpty
            v-if="mydata.articleListArr.length === 0"
            marginBottom="20px"
          ></glEmpty>
        </div>

        <!-- 模块4  -->
        <!--分页 -->
        <div
          class="gl-pagination"
          
        >
          <el-pagination
            v-model:currentPage="mydata.pageObj.currentPage"
            v-model:page-size="mydata.pageObj.pageSize"
            :total="mydata.pageObj.total"
            layout="prev, pager, next"
        pager-count="4"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>

      <!-- 活动区域 -->
      <div class="box-right">
        <activityResultsCard title="热门活动" :ele_have_scrollbar="true">
          <template #abc>
            <img
              v-for="(item, index) in mydata.hotActivity"
              :key="index"
              v-complete:src="item.image"
              style="cursor: pointer"
              @click="hotImgClick(item.id)"
            />
          </template>
        </activityResultsCard>
      </div>
    </div>
    <!-- 模块4  -->
    <!-- <div class="paging">
      <div class="demo-pagination-block">
        <el-pagination
          v-model:currentPage="mydata.currentPage3"
          v-model:page-size="mydata.pageSize3"
          :small="mydata.small"
          :disabled="mydata.disabled"
          :background="mydata.background"
          layout="prev, pager, next, jumper"
          :total="1000"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <el-button plain>确定</el-button>
    </div> -->
  </div>
</template>

<script>
// 是否来自其他模块
let fromOtherModule = false;
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "projectAchievements",
  beforeRouteEnter(to, from, next) {
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (
      [
        "/layout/list/projectAchievementsDetails",
        // "/layout/list/activityDetails",
      ].includes(from.path) === false
    ) {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>




<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";
import subjectButton from "@/components/subjectButton/index.vue";
import subjectButton2 from "@/components/subjectButton2/index.vue";
import bookBigListenCards from "@/components/bookBigListenCards/index.vue";

import worksDisplayCards2 from "@/components/worksDisplayCards2/index.vue";
import activityResultsCard from "@/components/activityResultsCard/index.vue";

// 引入接口
import { articleList, activityKeyword } from "@/api/home/index.js";

// 引入接口
import { getUrlId } from "@/utils/slide.js";
// 推荐列表接口
import { getRecommendList } from "@/api/recommend/index.js";
import { dictKeyWord } from "@/utils/dict.js";

import { reactive, onActivated } from "vue";
import { getSubject } from "@/api/dictionary/index.js";

import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  //筛选按钮
  filterButton1: {
    title: "学段",
    filter: JSON.parse(localStorage.getItem("stage2")) ?? [],
  },
  filterButton2: {
    title: "学科",
    filter: JSON.parse(localStorage.getItem("subject")) ?? [],
  },
  filterButton3: {
    title: "关键字",
    // filter: JSON.parse(localStorage.getItem("theme")) ?? [],
    filter: [],
  },

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  worksDisplay_path: "/layout/list/projectAchievementsDetails",
  articleListArr: [], // 文章列表

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 8, // 每页条数
    total: 0, // 总的条数
  },
  form: {
    column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询
    activity_grade: "", //学段
    theme: "", //主题
    subject: "", //学科
  },
  hotActivity: [], //热门活动

  testKey0: new Date().getTime() - Math.random() * 10,
  testKey: new Date().getTime() + Math.random() * 100,
  testKey2: new Date().getTime() - Math.random() * 1000,
});

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    //筛选按钮
    mydata.filterButton1 = {
      title: "学段",
      filter: JSON.parse(localStorage.getItem("stage2")) ?? [],
    };
    mydata.filterButton2 = {
      title: "学科",
      filter: JSON.parse(localStorage.getItem("subject")) ?? [],
    };
    mydata.filterButton3 = {
      title: "关键字",
      // filter: JSON.parse(localStorage.getItem("theme")) ?? [],
      filter: [],
    };
    // 基础地址
    mydata.VUE_APP_BASE_HOST = process.env.VUE_APP_BASE_HOST;
    mydata.worksDisplay_path = "/layout/list/projectAchievementsDetails";
    mydata.articleListArr = []; // 文章列表
    mydata.pageObj = {
      currentPage: 1, // 当前页数
      pageSize: 8, // 每页条数
      total: 0, // 总的条数
    };
    mydata.form = {
      column_id: getUrlId(route.path), // 栏目id值
      search: "", // 搜索查询
      activity_grade: "", //学段
      theme: "", //主题
      subject: "", //学科
    };
    mydata.hotActivity = []; //热门活动
    mydata.testKey0 = new Date().getTime() - Math.random() * 10;
    mydata.testKey = new Date().getTime() + Math.random() * 100;
    mydata.testKey2 = new Date().getTime() - Math.random() * 1000;
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  if (route.query.search !== undefined) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1;
    mydata.form.search = route.query.search;
    // getData()
    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    router.push({
      path: "/layout/list/projectAchievements",
    });
  }

  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  getKeyWord();
  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  getRecommendFn();
  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  articleListFn();
});

function getKeyWord() {
  activityKeyword({ type: "1" }).then((res) => {
    // 全的
    mydata.filterButton3.filter = res.data.map((item) => {
      item.label = item.keyword;
      item.name = item.id;
      return item;
    });
  });
}
////////////////////////////////////////////
//推荐列表 热门活动
function getRecommendFn() {
  // 使用标题在字典中进行匹配，得到对应的keyword值
  let keyword = dictKeyWord["教师热门活动"];
  getRecommendList({
    keyword: keyword,
    page: 1,
    psize: 10,
    column_key: route.path,
  }).then((res) => {
    mydata.hotActivity = res.data.list;
  });
}

// getRecommendFn();

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  articleListFn();
}

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 查询列表
function queryList(dict, inputValue) {
  // 分页变成第一页
  mydata.pageObj.currentPage = 1;
  // 赋值
  mydata.form.search = inputValue;
  // 查询
  articleListFn();
}

// 学段单选改变事件
function change1(val) {
  mydata.filterButton2.filter = [];
  mydata.form.subject = "";
  mydata.filterButton3.filter = [];
  mydata.form.theme = "";
  let stage = "";
  if (val) {
    stage = mydata.filterButton1.filter.find((item) => {
      return item.name === val;
    }).label;
  }
  getSubject({
    stage_id: val,
    stage: stage,
  }).then((res) => {
    // console.log(res);

    mydata.filterButton2.filter = res.data.map((item) => {
      item.name = item.id;
      return item;
    });
    mydata.testKey = new Date().getTime() + Math.random();
  });

  activityKeyword({ type: "1", stage_id: val, stage: stage }).then((res) => {
    // 全的
    mydata.filterButton3.filter = res.data.map((item) => {
      item.label = item.keyword;
      item.name = item.id;
      return item;
    });
    ///////////////
    // mydata.filterButton3.filter = [
    //   ...mydata.filterButton3.filter,
    //   {
    //     label: "1测试啊啊啊啊啊啊啊啊",
    //     name: 1,
    //   },
    //   {
    //     label: "2测试啊啊啊啊啊啊啊啊",
    //     name: 2,
    //   },
    //   {
    //     label: "3测试啊啊啊啊啊啊啊啊",
    //     name: 3,
    //   },
    //   {
    //     label: "4测试啊啊啊啊啊啊啊啊",
    //     name: 4,
    //   },
    //   {
    //     label: "5测试啊啊啊啊啊啊啊啊",
    //     name: 5,
    //   },
    //   {
    //     label: "6测试啊啊啊啊啊啊啊啊",
    //     name: 6,
    //   },
    //   {
    //     label: "7测试啊啊啊啊啊啊啊啊",
    //     name: 7,
    //   },
    //   {
    //     label: "8测试啊啊啊啊啊啊啊啊",
    //     name: 8,
    //   },
    //   {
    //     label: "9测试啊啊啊啊啊啊啊啊",
    //     name: 9,
    //   },
    //   {
    //     label: "10测试啊啊啊啊啊啊啊啊",
    //     name: 10,
    //   },
    //   {
    //     label: "11测试啊啊啊啊啊啊啊啊",
    //     name: 11,
    //   },
    //   {
    //     label: "12测试啊啊啊啊啊啊啊啊",
    //     name: 12,
    //   },
    //   {
    //     label: "13测试啊啊啊啊啊啊啊啊",
    //     name: 13,
    //   },
    //   {
    //     label: "14测试啊啊啊啊啊啊啊啊",
    //     name: 14,
    //   },
    //   {
    //     label: "15测试啊啊啊啊啊啊啊啊",
    //     name: 15,
    //   },
    // ];
    ///////////////
    mydata.testKey2 = new Date().getTime() - Math.random();
  });

  // 赋值
  mydata.form.activity_grade = val;
  // 查询
  articleListFn();
}

// 类型单选框改变事件
function change2(val) {
  mydata.form.theme = val;
  // 查询
  articleListFn();
}

// 学科单选框改变事件
function change3(val) {
  mydata.form.subject = val;
  // 查询
  articleListFn();
}

// 查询

// 查询
// articleListFn();

function hotImgClick(id) {
  router.push({
    path: "/layout/list/activityDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.taoBao {
  background-color: #f9f9f9;
  padding-bottom: 40px;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

 ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    margin-bottom: 16px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
      .box2 {
        display: none;
      }
    }
  }
  //////模块2------搜索组件 和 按钮组件
  .box-worksdisplay1 {
    background-color: #ffffff;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 16px;
    padding: 16px 0px;
    overflow: hidden;
   
  }
  ///////模块3
  .box-worksdisplay2 {
    width: 343px;
    // height: 1352px;
    margin: 0 auto;
    // border: 1px solid blue;
    // padding: 30px;
    border-radius: 8px;
    // display: flex;
    // justify-content: space-between;
    .box-left {
      width: 343px;
      // height: 972px;
      // border:1px solid red;
      > div:nth-of-type(1) {
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        // align-items: flex-start;
        overflow: hidden;
        overflow: visible;
      }
      .box-worksDisplayCards {
        // box-shadow: 2px 2px 4px #c5cbce90;

        margin-bottom: 16px;
        // border:1px solid red;
      }
    }
    .box-right {
      width: 343px;
      //border:1px solid rgb(255, 174, 0);
      border-radius: 8px;
      margin-top:16px;
      :deep(.activity-results) {
        // width: 320px;
        // border:1px solid red;
        .box-content {
          height:550px;
         padding: 10px;
        border-radius: 8px;
        background-color: #ffffff !important;
       

          img {
           width: 100%;
          // height: 145px;
          border-radius: 8px;
          margin-bottom: 10px;
          display: block;
          }
          img:nth-last-of-type(1) {
            margin-bottom: 0px;
          }
        }
      }
    }
  }

  /* 滚动条轨道样式 */
  // ::-webkit-scrollbar {
  //   width: 5px; /* 设置滚动条宽度 */
  //   height:10px;
  // }

  // /* 滚动条滑块样式 */
  // ::-webkit-scrollbar-thumb {
  //   background-color: rgb(204,204,204); /* 设置滑块背景颜色 */
  //   border-radius: 4px; /* 设置滑块圆角 */
  // }

  // /* 滚动条轨道hover状态样式 */
  // ::-webkit-scrollbar-track:hover {
  //   background-color: rgb(204,204,204); /* 设置轨道hover状态时的背景颜色 */
  // }

  // /* 滚动条滑块hover状态样式 */
  // ::-webkit-scrollbar-thumb:hover {
  //   background-color: rgb(204,204,204); /* 设置滑块hover状态时的背景颜色 */
  // }

  //////////分页
  .paging {
    height: 32px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    // margin-bottom: 40px;
    // border:1px solid red;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
</style>
